import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import renovation from "./modules/renovation";

const state = {};
const mutations = {};

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    renovation,
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js